import React from 'react';
import protoaiData from '../data/protoai-data.json';

// protoAI Components
import PageHero from './components-protoai/PageHero';

// Original Appiya Component
import Pricing from './components-home/Pricing';

const PricingPage = () => {
  // Transform protoai data to match Pricing component structure
  const pricingData = {
    sectiontitle: protoaiData.pricing.sectionTitle || '料金プラン',
    tables: protoaiData.pricing.plans.map(plan => ({
      title: plan.name,
      currency: '¥',
      price: plan.price.replace(/[¥,]/g, ''),
      duration: plan.duration,
      description: plan.description,
      features: plan.features,
      btnLabel: plan.btnLabel || 'このプランで相談する',
      url: '#contact',
      recommended: plan.recommended || false
    }))
  };

  return (
    <div>
      {/* ページヘッダー */}
      <PageHero
        title="料金プラン"
        subtitle="透明性の高い料金体系で、お客様の未来への投資をサポートします"
        breadcrumb="料金"
      />

      {/* 料金プラン詳細 - Appiyaコンポーネント使用 */}
      <Pricing data={pricingData} />
    </div>
  );
};

export default PricingPage;